"use client"

import { ItemCollapsibleInfoCard } from "@/app/item/view/item-info-card"
import { useNftReatom } from "@/app/nft/store/hooks.reatom"
import { Trans } from "@lingui/react/macro"
import { reatomComponent } from "@reatom/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import { Counter } from "./counter"
import { NftTraits, TraitSkeletons } from "./traits"
import { useNftTraitsReatom } from "./use-nft-traits.reatom"

export function NftTraitsViewReatom() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<NftTraitsSkeleton />}>
        <NftTraitsContentReatom />
      </Suspense>
    </ErrorBoundary>
  )
}

const NftTraitsContentReatom = reatomComponent(() => {
  const traits = useNftTraitsReatom()
  const nft = useNftReatom()

  if (!traits.length) return null

  return (
    <ItemCollapsibleInfoCard
      header={<TraitsHeader badge={<Counter count={traits.length} />} />}
      content={<NftTraits traits={traits} nft={nft} />}
    />
  )
})

function NftTraitsSkeleton() {
  return (
    <ItemCollapsibleInfoCard
      header={<TraitsHeader badge={null} />}
      content={<TraitSkeletons />}
    />
  )
}

function TraitsHeader(props: { badge: React.ReactNode }) {
  return (
    <div className="flex h-[26px] items-center gap-1">
      <Trans>Traits</Trans>
      {props.badge}
    </div>
  )
}
